export enum ChallengeGoalType {
  CollectNumberGoals = 'COLLECT_NUMBER_GOALS',
  CollectGoalsTilDeadline = 'COLLECT_GOALS_TILL_DEADLINE',
  CollectMax = 'COLLECT_MAX',
}
